<script>
  import { createEventDispatcher } from 'svelte';
  import { formatShortDate, getTime } from '../../../common/dates';

  const dispatch = createEventDispatcher();

  export let selectedRecording;
  export let recordings = [];

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };
</script>

<div class="container">
  <header>
    <button class="refresh-btn" on:click={() => dispatch('refreshrecordings')}>
      <span class="material-icons"> refresh </span>
    </button>
  </header>
  <div class="recordings">
    {#if recordings.length}
      {#each recordings as recording}
        <div
          class="recording"
          class:selected={recording.id === selectedRecording?.id}
          on:click={() => dispatch('recordingselected', recording)}
        >
          <span>{formatShortDate(recording.modified)}</span>
          <span class="time">{getTime(recording.modified)}</span>
          <p class="size">{formatBytes(recording.size)}</p>
        </div>
      {/each}
    {:else}
      <div class="info">
        <p>Ingen videoer funnet</p>
      </div>
    {/if}
  </div>
</div>

<style src="./videoList.scss"></style>
